<template>
    <div no-body id="print">
        <modal :size="'xl'" :show.sync="modals.addNote">
            <h6 slot="header" class="modal-title">Note</h6>
            <form class="form-group">
                <base-input>
                    <textarea resize="none" class="form-control" name="" placeholder="Add note" id="note-description" cols="20" rows="3" v-model="modals.note"></textarea>
                </base-input>
            </form>
            <template slot="footer">
                <base-button type="primary" @click.prevent="underDevelopment()">Create / Save</base-button>
                <base-button type="link" class="ml-auto" @click.self="closeModal()">Close</base-button>
            </template>
        </modal>
        <b-row class="mx-2">
            <b-col>
                <card> 
                    <div slot="header">
                        <b-row >
                            <b-col cols="6">
                                <h1 class="mb-0">Cash Flow Statement</h1>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <base-button type="primary" icon size="sm" @click="underDevelopment()">
                                    <span class="btn-inner--text">Send KYC To Customer</span>
                                </base-button>
                                <base-button type="primary" icon size="sm" v-b-toggle.collapse-3>
                                    <span class="btn-inner--icon"><i class="fas fa-caret-down"></i></span>
                                </base-button>
                            </b-col>
                        </b-row>
                    </div>
                    <!-- Card body -->
                    <b-collapse id=collapse-3 visible class="mx-6">
                        <div>
                            <h5 class="text-danger"> Note : <br>
                                <i>
                                    1. The blue color value indicated the value filled by customer.
                                </i>
                                <br>
                                <i>
                                    2. The gray color value indicated the value auto calculated by system.
                                </i>
                                <br>
                                <i>
                                    3. If the monthly column is being filled up, the annual value will be auto calculated; Vice versa.
                                </i>
                                <br>
                                <i>
                                    4. Advisory can only edit the column filled up by customer, if monthly column is filled up, advisory can only update the monthly column.
                                </i>
                                <br>
                                <i v-if="inputGrossIncome"><b>
                                    5. You have manually input the gross income for this customer, the auto calculated gross income should be RM {{autoGrossIncome.admin_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}
                                </b></i>
                            </h5>
                            <br> 
                            <h2>{{cashIncomes[0].Cust_Info.Cust_Name}}</h2>
                            <table style="margin-bottom:20px">
                                <tr class="text-white">
                                    <th></th>
                                    <th style="width:5%">Note</th>
                                    <th colspan="2">Customer Answer (RM)</th>
                                    <th colspan="2">Advisory Answer (RM)</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>Yearly</td>
                                    <td>Monthly</td>
                                    <td style="width:50px">Yearly</td>
                                    <td style="width:50px">Monthly</td>
                                </tr>
                                <!-- cash infow -->
                                <template>
                                    <tr>
                                        <td colspan="6"><b>Cash Inflow - from DSR</b></td>
                                    </tr>
                                    <tr v-for="cashIncome in cashIncomes[0].Income_Info.plus_info" :key="cashIncome.customer_income_id">
                                        <td class="pl-4">
                                            {{cashIncome.income_type}}
                                        </td>
                                        <!-- <td><el-input size="small" v-model="cashIncome.remark"/></td> -->
                                        <td v-if="cashIncome.income_type != 'Rental Income'">
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('income_'+cashIncome.customer_income_id)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>
                                        </td>
                                        <td v-else></td>
                                        <td>{{cashIncome.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{cashIncome.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="incomeAdminValue.plus_info[cashIncome.customer_income_id]">{{incomeAdminValue.plus_info[cashIncome.customer_income_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td><el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncome.admin_value"/></td>
                                    </tr>
                                    <tr>
                                        <td class="pl-4">Gross Income</td>
                                        <td></td>
                                        <td>{{cashIncomes[0].Income_Info.gross_income.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{cashIncomes[0].Income_Info.gross_income.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray">{{incomeAdminValue.gross_income.admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td>
                                            <el-input type="number" min="0" size="small" id="admin-value" v-model="incomeAdminValue.gross_income.admin_month" @input="updateGrossIncomeAdminValue()">
                                                <template #append v-if="inputGrossIncome">
                                                    <base-button type="primary" icon size="sm" @click.prevent="resetGrossIncomeAdminValue()">
                                                        <!-- <span class="fas fa-trash"></span> -->
                                                        <span class="btn-inner--text">Reset</span>
                                                    </base-button>
                                                </template>
                                            </el-input>
                                        </td>
                                    </tr>
                                    <template>
                                        <tr>
                                            <td class="pl-4">Avg Bonus</td>
                                            <td>
                                                <base-button type="primary" icon size="sm" @click.prevent="openModal(cashIncomes[0].Income_Info.bonus_income.customer_income_id)">
                                                    <span class="fa fa-plus"></span>
                                                    <span class="btn-inner--text">Note</span>
                                                </base-button>
                                            </td>
                                            <td>{{cashIncomes[0].Income_Info.bonus_income.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>{{cashIncomes[0].Income_Info.bonus_income.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td class="text-gray">{{(cashIncomes[0].Income_Info.bonus_income.admin_value * 12).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncomes[0].Income_Info.bonus_income.admin_value"/>
                                            </td>
                                        </tr>
                                    </template>
                                    <!-- rental income -->
                                    <template>
                                        <tr>
                                            <td class="pl-4">Rental Income
                                                <base-button type="primary" icon size="sm" v-if="cashIncomes[0].Income_Info.rental_income.rental_detail" @click.prevent="isExpand = !isExpand">
                                                    <span class="fa fa-plus"></span>
                                                </base-button>
                                            </td>
                                            <td v-if="!cashIncomes[0].Income_Info.rental_income.rental_detail">
                                                <base-button type="primary" icon size="sm" @click.prevent="openModal('rental_'+cashIncome.customer_income_id)">
                                                    <span class="fa fa-plus"></span>
                                                    <span class="btn-inner--text">Note</span>
                                                </base-button>
                                            </td>
                                            <td v-else></td>
                                            <td><b>{{cashIncomes[0].Income_Info.rental_income.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{cashIncomes[0].Income_Info.rental_income.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{incomeAdminValue.total_rental_income.admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td v-if="cashIncomes[0].Income_Info.rental_income.rental_detail">
                                                <b>{{incomeAdminValue.total_rental_income.admin_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                            </td>
                                            <td v-else>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncomes[0].Income_Info.rental_income.admin_value" @input="updateTotalRentalIncomeAdminValue()"/>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-show="isExpand" v-for="rentalIncome in cashIncomes[0].Income_Info.rental_income.rental_detail" :key="rentalIncome.id">
                                        <td class="pl-5">{{rentalIncome.income_type}}</td>
                                        <td>
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('rental_'+rentalIncome.customer_income_id)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>
                                        </td>
                                        <td>{{rentalIncome.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{rentalIncome.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="incomeAdminValue.rental_detail[rentalIncome.customer_income_id]">{{incomeAdminValue.rental_detail[rentalIncome.customer_income_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td><el-input type="number" min="0" size="small" id="admin-value" v-model="rentalIncome.admin_value"/></td>
                                    </tr>
                                    
                                    <tr v-for="cashIncome in cashIncomes[0].Income_Info.minus_info" :key="cashIncome.customer_income_id">
                                        <td class="pl-4">(-) {{cashIncome.income_type}}</td>
                                        <!-- <td><el-input size="small" v-model="cashIncome.remark"/></td> -->
                                        <td>
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('income_'+cashIncome.customer_income_id)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>                                        
                                        </td>
                                        <td>{{cashIncome.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{cashIncome.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="incomeAdminValue.minus_info[cashIncome.customer_income_id]">{{incomeAdminValue.minus_info[cashIncome.customer_income_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td><el-input type="number" min="0" size="small" id="admin-value" v-model="cashIncome.admin_value"/></td>
                                    </tr>
                                    <tr>
                                        <td><b>Total Inflow</b></td>
                                        <td></td>
                                        <td><b>{{cashIncomes[0].Income_Info.Annual_Net_Income.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{cashIncomes[0].Income_Info.Net_Income.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalIncomeAdminValue.total_inflow.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td :v-on:change="test()"><b>{{totalIncomeAdminValue.total_inflow.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <!-- cash outflow -->
                                <template>
                                    <tr>
                                        <td colspan="6"><b>Cash Outflow</b></td>
                                    </tr>
                                    <tr>
                                        <td class="pl-4" colspan="6"><b>Fixed Expenses - from IM2U</b></td>
                                    </tr>
                                    <tr v-for="fixedExpense in fixedExpenses[0].im2u_liabilities" :key="fixedExpense.loan_statue_name">
                                        <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                        <!-- <td>
                                            <el-input size="small" id="remark_note" v-on:input="debounceInput(customerAnswer.answer.answer_id, customerAnswer.answer.admin_value)" v-model="fixedExpense.remark"></el-input>
                                        </td> -->
                                        <td>
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('fixedExpense_'+fixedExpense.im2u_liability_id)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>                                        
                                        </td>
                                        <td>{{fixedExpense.customer_annual_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-blue">{{fixedExpense.customer_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td class="text-gray" v-if="expenseAdminValue.fixed[fixedExpense.im2u_liability_id] != undefined">{{expenseAdminValue.fixed[fixedExpense.im2u_liability_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                        <td>
                                            <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_month_curr_installment"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pl-4"><b>Total Fixed Expenses</b></td>
                                        <td></td>
                                        <td><b>{{fixedExpenses[0].total_annual_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{fixedExpenses[0].total_month_curr_installment.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.fixed.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.fixed.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td class="pl-4" colspan="6"><b>Variable Expenses - from KYC</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td class="pl-4" colspan="6"><b>Variable Expenses</b></td>
                                    </tr>
                                    <tr v-for="variableExpense in variableExpenses[0].customer_expenses" :key="variableExpense.customer_question_column">
                                        <td class="pl-5">{{variableExpense.customer_question_column}}</td>
                                        <!-- <td>
                                            <el-input size="small" id="remark_note" v-model="variableExpense.remark"></el-input>
                                        </td> -->
                                        <td>
                                            <base-button type="primary" icon size="sm" @click.prevent="openModal('variableExpense_'+variableExpense.kyc_data_id)">
                                                <span class="fa fa-plus"></span>
                                                <span class="btn-inner--text">Note</span>
                                            </base-button>                                        
                                        </td>
                                        <template v-if="variableExpense.frequency_id == 2">
                                            <td>{{variableExpense.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td class="text-blue">{{variableExpense.customer_month_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <template v-if="expenseAdminValue.variable[variableExpense.kyc_data_id]">
                                                <td class="text-gray">{{expenseAdminValue.variable[variableExpense.kyc_data_id].admin_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                <td>
                                                    <el-input type="number" min="0" size="small" id="admin-value" v-model="variableExpense.admin_month_value"></el-input>
                                                </td>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <td class="text-blue">{{variableExpense.customer_annual_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>{{variableExpense.customer_month_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <template v-if="expenseAdminValue.variable[variableExpense.kyc_data_id]">
                                                <td>
                                                    <el-input type="number" min="0" size="small" id="admin-value" v-model="variableExpense.admin_annual_value"></el-input>
                                                </td>
                                                <td class="text-gray">{{expenseAdminValue.variable[variableExpense.kyc_data_id].admin_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            </template>
                                        </template>
                                        
                                    </tr>
                                    <tr>
                                        <td class="pl-4"><b>Total Variable Expenses</b></td>
                                        <td></td>
                                        <td><b>{{variableExpenses[0].total.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{variableExpenses[0].total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.variable.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.variable.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>Total Outflow</b></td>
                                        <td></td>
                                        <td><b>{{(fixedExpenses[0].total_annual_curr_installment+variableExpenses[0].total).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{(fixedExpenses[0].total_month_curr_installment+variableExpenses[0].total_month).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.total_outflow.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalExpenseAdminValue.total_outflow.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <tr>
                                    <td><b>Net Inflow/Outflow</b></td>
                                    <td></td>
                                    <td><b>{{(cashIncomes[0].Income_Info.Annual_Net_Income - (fixedExpenses[0].total_annual_curr_installment+variableExpenses[0].total)).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    <td><b>{{(cashIncomes[0].Income_Info.Net_Income - (fixedExpenses[0].total_month_curr_installment+variableExpenses[0].total_month)).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    <td><b>{{totalNetFlow.total_annual.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    <td><b>{{totalNetFlow.total_month.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                </tr>
                            </table>
                        </div>
                        <!-- <div v-else class="text-center"> -->
                            <!-- We dont have any information about this customer. -->
                        <!-- </div> -->
                    </b-collapse>
                    <br>
                    <!-- <b-col class="text-center">
                        <base-button type="primary" icon size="sm" @click.prevent="close()">Back / Close</base-button>
                    </b-col> -->
                </card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import axios from 'axios'
    import {apiGatewayDomain, getHeader} from '@/assets/js/config.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    import cashIncomesData from './cashincomes';
    import fixedExpensesData from './fixedexpenses';
    import variableExpensesData from './variableexpenses';
    import {getUserInfo} from '@/assets/js/config.js'

    export default {
        mixins: [notifyFunctionMixin],
        components: {
        },
        data() {
            return {
                cashIncomesData,
                fixedExpensesData,
                variableExpensesData,
                loginUser : getUserInfo(),
                modals: {
                    addNote: false,
                    note_type_id: null,
                    note: null,
                },
                isExpand: true,
                inputGrossIncome: false,
                autoGrossIncome: {},
                incomeAdminValue: {
                    plus_info: [],
                    gross_income: {
                        admin_month: 0,
                        admin_annual: 0,
                    },
                    bonus_income: {
                        admin_month: 0,
                        admin_annual: 0,
                    },
                    rental_detail: [],
                    total_rental_income: {
                        admin_month: 0,
                        admin_annual: 0,
                    },
                    minus_info: [],
                },
                totalIncomeAdminValue: {
                    plus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    minus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_inflow: {
                        total_month: 0,
                        total_annual: 0,
                    },
                },
                expenseAdminValue: {
                    fixed: {},
                    variable: {},
                },
                totalExpenseAdminValue: {
                    fixed: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    variable: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_outflow: {
                        total_month: 0,
                        total_annual: 0,
                    }
                },
                totalNetFlow: {
                    total_month: 0,
                    total_annual: 0,
                }
            };
        },
        created() {
            // this.getCustomerIncomeData();
            this.fixedExpensesData = {...this.fixedExpensesData};
            this.variableExpensesData = {...this.variableExpensesData};
            this.cashIncomesData = {...this.cashIncomesData};
        },
        computed:{
            fixedExpenses() {
                const {fixedExpensesData} = this
                return fixedExpensesData
            },
            variableExpenses() {
                const {variableExpensesData} = this
                return variableExpensesData
            },
            cashIncomes() {
                const {cashIncomesData} = this
                return cashIncomesData;
            }
        },
        watch: {
            fixedExpenses: {
                handler: function(val) {
                    let expenseAdminValue = {...this.expenseAdminValue}
                    val[0].im2u_liabilities.filter( function( data, idx ) {
                        // cannot direct update back to the json data, will cause infinite loop
                        if(isNaN(data.admin_annual_curr_installment))
                        {
                            data.admin_annual_curr_installment = 0;
                        }

                        if(isNaN(data.admin_month_curr_installment))
                        {
                            data.admin_month_curr_installment = 0;
                        }

                        expenseAdminValue.fixed = {
                            ...expenseAdminValue.fixed,
                            [data.im2u_liability_id]: {
                                admin_month: parseFloat(data.admin_month_curr_installment),
                                admin_annual: parseFloat(data.admin_month_curr_installment * 12)
                            },
                        };
                    });
                    this.expenseAdminValue = expenseAdminValue;

                    this.getNetFlow();
                                     
                },
                deep: true,
            },
            variableExpenses: {
                handler: function(val) {
                    let expenseAdminValue = {...this.expenseAdminValue}
                    val[0].customer_expenses.filter( function( data, idx ) {
                        // cannot direct update back to the json data, will cause infinite loop
                        if(isNaN(data.admin_annual_value))
                        {
                            data.admin_annual_value = 0;
                        }

                        if(isNaN(data.admin_month_value))
                        {
                            data.admin_month_value = 0;
                        }

                        if(data.frequency_id == 2) {
                            expenseAdminValue.variable = {
                                ...expenseAdminValue.variable,
                                [data.kyc_data_id]: {
                                    admin_month: parseFloat(data.admin_month_value),
                                    admin_annual: parseFloat(data.admin_month_value * 12)
                                },
                            };
                        }
                        else
                        {
                            expenseAdminValue.variable = {
                                ...expenseAdminValue.variable,
                                [data.kyc_data_id]: {
                                    admin_month: parseFloat((data.admin_annual_value / 12).toFixed(2)),
                                    admin_annual: parseFloat(data.admin_annual_value)
                                },
                            };
                        }
                    });
                    this.expenseAdminValue = expenseAdminValue;

                    this.getNetFlow();
                                     
                },
                deep: true,
            },
            cashIncomes: {
                handler: function(val) {
                    let incomeAdminValue = this.incomeAdminValue;
                    let totalRentalIncome = {
                        total_month: 0,
                        total_annual: 0,
                    };
                    // console.log(this.cashIncomesData[0].Income_Info.plus_info);

                    // plus info
                    val[0].Income_Info.plus_info.filter(function(data, idx) {
                        if(isNaN(data.admin_value))
                        {
                            data.admin_value = 0;
                        }
                        // problem
                        if(data.admin_value == null)
                        {
                            data.admin_value = data.customer_value;
                        }
                        
                        incomeAdminValue.plus_info = {
                            ...incomeAdminValue.plus_info,
                            [data.customer_income_id]: {
                                admin_month: parseFloat(data.admin_value),
                                admin_annual: parseFloat(data.admin_value * 12)
                            }
                        }
                    });

                    // bonus income
                    if(isNaN(val[0].Income_Info.bonus_income.admin_value))
                    {
                        val[0].Income_Info.bonus_income.admin_value = 0;
                        incomeAdminValue.bonus_income = {
                            admin_month: parseFloat(val[0].Income_Info.bonus_income.admin_value),
                            admin_annual: parseFloat(val[0].Income_Info.bonus_income.admin_value * 12)
                        }
                    }
                    else
                    {
                        // problem
                        if(val[0].Income_Info.bonus_income.admin_value == null)
                        {
                            val[0].Income_Info.bonus_income.admin_value = val[0].Income_Info.bonus_income.customer_value;
                        }
                        incomeAdminValue.bonus_income = {
                            admin_month: parseFloat(val[0].Income_Info.bonus_income.admin_value),
                            admin_annual: parseFloat(val[0].Income_Info.bonus_income.admin_value * 12)
                        }
                    }

                    // rental detail
                    if(val[0].Income_Info.rental_income.rental_detail != undefined)
                    {
                        val[0].Income_Info.rental_income.rental_detail.filter(function(data, idx) {
                            // problem
                            if(data.admin_value == null)
                            {
                                data.admin_value = data.customer_value;
                            }
                            incomeAdminValue.rental_detail = {
                                ...incomeAdminValue.rental_detail,
                                [data.customer_income_id]: {
                                    admin_month: parseFloat(data.admin_value),
                                    admin_annual: parseFloat(data.admin_value * 12)
                                }
                            }
                            totalRentalIncome.total_month += parseFloat(data.admin_value);
                            totalRentalIncome.total_annual = totalRentalIncome.total_month * 12;
                        });
                        
                        /**
                         * Axios here to save the rental income admin value to db 
                         * not sure will cause low performance issue or not
                         */
                    }
                    else
                    {
                        totalRentalIncome.total_month = parseFloat(val[0].Income_Info.rental_income.admin_value);
                        totalRentalIncome.total_annual = parseFloat(val[0].Income_Info.rental_income.admin_value * 12);
                    }
                    // this.totalRentalIncomeAdminValue = totalRentalIncome;
                    this.incomeAdminValue.total_rental_income.admin_annual = totalRentalIncome.total_annual
                    this.incomeAdminValue.total_rental_income.admin_month = totalRentalIncome.total_month

                    // minus info
                    val[0].Income_Info.minus_info.filter(function(data, idx) {
                        if(isNaN(data.admin_value))
                        {
                            data.admin_value = 0;
                        }
                        // problem
                        if(data.admin_value == null)
                        {
                            data.admin_value = data.customer_value;
                        }
                        
                        incomeAdminValue.minus_info = {
                            ...incomeAdminValue.minus_info,
                            [data.customer_income_id]: {
                                admin_month: parseFloat(data.admin_value),
                                admin_annual: parseFloat(data.admin_value * 12)
                            }
                        }
                    });

                    // gross income
                    this.incomeAdminValue = incomeAdminValue;

                    this.getNetFlow();

                },
                deep: true,
            }
        },
        methods: {
            test() {
                console.log('hihi');
            },
            close() {
                this.$router.back();
            },
            openModal(note_type_id) {
                this.modals.addNote = true;
                this.modals.note_type_id = note_type_id;
                this.modals.note = null;
                this.resetModal();
            },
            closeModal() {
                this.modals.addNote = false;
                this.resetModal()
            },
            resetModal() {
                this.modals.note = null;
            },
            getCustomerIncomeData() {
                axios.get(apiGatewayDomain + 'financial_proposal/get_customer_income/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                if (response.status === 200)
                {
                    this.cashIncomesData = response.data
                }
                })
                .catch ( error => {
                    console.log(error.response.status)
                    this.errorFunction(error, "Show Customer Income")
                });
            },
            resetGrossIncomeAdminValue() {
                this.inputGrossIncome = false;
                this.getNetFlow();
            },
            updateGrossIncomeAdminValue() {
                this.inputGrossIncome = true;
                this.incomeAdminValue.gross_income.admin_annual = this.incomeAdminValue.gross_income.admin_month * 12;
                this.getNetFlow();
            },
            updateTotalRentalIncomeAdminValue() {
                this.incomeAdminValue.total_rental_income.admin_annual = this.cashIncomesData[0].Income_Info.rental_income.admin_value * 12;
            },
            getGrossIncome() {
                let grossIncome = {
                    admin_annual: 0,
                    admin_month: 0,
                }
                let manualInput = parseFloat(this.incomeAdminValue.gross_income.admin_month);

                Object.values(this.incomeAdminValue.plus_info).forEach((data) => {
                    if(isNaN(data.admin_month))
                    {
                        data.admin_month = 0;
                        data.admin_annual = 0;
                    }

                    grossIncome.admin_annual += data.admin_annual;
                    grossIncome.admin_month += data.admin_month;
                }); 

                this.autoGrossIncome = {...grossIncome};
            
                if(this.inputGrossIncome)
                {
                    grossIncome.admin_annual = manualInput * 12;
                    grossIncome.admin_month = manualInput;
                }
                /**
                 * axios here to save gross income for admin value to db
                 */
                 this.incomeAdminValue.gross_income = grossIncome;
            },
            getInflow() {
                let totalIncomeAdminValue = {
                    plus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    minus_info: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_inflow: {
                        total_month: 0,
                        total_annual: 0,
                    },
                };

                this.getGrossIncome();

                /** get total plus info */
                if(isNaN(this.incomeAdminValue.bonus_income.admin_month))
                {
                    this.incomeAdminValue.bonus_income.admin_month = 0;
                    this.incomeAdminValue.bonus_income.admin_annual = 0;
                }

                totalIncomeAdminValue.plus_info.total_month += this.incomeAdminValue.bonus_income.admin_month;
                totalIncomeAdminValue.plus_info.total_month += this.incomeAdminValue.total_rental_income.admin_month;
                totalIncomeAdminValue.plus_info.total_annual = totalIncomeAdminValue.plus_info.total_month * 12;
                
                /** get total minus info */
                Object.values(this.incomeAdminValue.minus_info).forEach((data) => {
                    if(isNaN(data.admin_month))
                    {
                        data.admin_month = 0;
                    }
                    totalIncomeAdminValue.minus_info.total_month += data.admin_month;
                });
                totalIncomeAdminValue.minus_info.total_annual = totalIncomeAdminValue.minus_info.total_month * 12;

                totalIncomeAdminValue.total_inflow.total_annual = this.incomeAdminValue.gross_income.admin_annual + totalIncomeAdminValue.plus_info.total_annual - totalIncomeAdminValue.minus_info.total_annual;
                totalIncomeAdminValue.total_inflow.total_month = this.incomeAdminValue.gross_income.admin_month + totalIncomeAdminValue.plus_info.total_month - totalIncomeAdminValue.minus_info.total_month;

                this.totalIncomeAdminValue = totalIncomeAdminValue;
            },
            getOutflow() {
                let totalExpenseAdminValue = {
                    fixed: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    variable: {
                        total_month: 0,
                        total_annual: 0,
                    },
                    total_outflow: {
                        total_month: 0,
                        total_annual: 0,
                    }
                };
                Object.keys(this.expenseAdminValue).forEach((key) => {
                    Object.values(this.expenseAdminValue[key]).forEach((data) => {
                        if(isNaN(data.admin_annual))
                        {
                            data.admin_annual = 0;
                        }

                        if(isNaN(data.admin_month))
                        {
                            data.admin_month = 0;
                        }
                        totalExpenseAdminValue[key].total_annual += data.admin_annual;
                        totalExpenseAdminValue[key].total_month += data.admin_month;
                    });   
                });

                totalExpenseAdminValue.total_outflow.total_annual = totalExpenseAdminValue.fixed.total_annual + totalExpenseAdminValue.variable.total_annual;
                totalExpenseAdminValue.total_outflow.total_month = totalExpenseAdminValue.fixed.total_month + totalExpenseAdminValue.variable.total_month;

                this.totalExpenseAdminValue = totalExpenseAdminValue;
            },
            getNetFlow() {
                this.getInflow();
                this.getOutflow();

                let totalNetFlow = {
                    total_month: 0,
                    total_annual: 0,
                };
                totalNetFlow.total_month = this.totalIncomeAdminValue.total_inflow.total_month - this.totalExpenseAdminValue.total_outflow.total_month;
                totalNetFlow.total_annual = this.totalIncomeAdminValue.total_inflow.total_annual - this.totalExpenseAdminValue.total_outflow.total_annual;
                this.totalNetFlow = totalNetFlow;
                
                const cashFlowStatementData = {
                    cash_inflow: {...this.totalIncomeAdminValue.total_inflow},
                    cash_outflow: {...this.totalExpenseAdminValue},
                };

                this.$emit('cash-flow-statement-data', cashFlowStatementData);
            }
        }
    };
</script>
<style scoped>
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td , th {
    border: 1px solid #dddddd;
    text-align: center;
    /* height: 10px; */
    /* width: 20%; */
}

td:first-child {
    text-align: left;
    padding-left: 8px;
}

th {
    background-color: #525f7f;
    font-size: large;
    width: 20%;
}

.button-right {
    padding-right: 0;
}
</style>
<style>
#admin-value {
    text-align:center;
    font-size:medium;
}
</style>